export default "__VITE_ASSET__r8x9d2zE__"